import { useNearbyMembers } from "../../../hooks/members/useNearbyMembers"
import { MemberSearchList } from "./MemberSearchList";

type Props = {
    search?: string;
}

export const NearbyMembers = ({ search }: Props) => {
    const { list, loading } = useNearbyMembers(search);
    return (
        <>
            {search && (
                <>
                    <hr />
                    <div className="members-page">
                        <div className="members-page__header">
                        <h1 className="members-page__title">
                            Nearby Members
                        </h1>
                        </div>
                        <MemberSearchList 
                            data={list as any}
                            loading={loading}
                        />
                    </div>
                </>
            )}
        </>
    )
}